export enum TaskTabIdEnum {
  Description = 0,
  Communication = 1,
  Attachments = 2,
  LinkedTasks = 3,
  Subtasks = 4,
}

export const COMMUNICATION_TABS = [TaskTabIdEnum.Communication];
export const TASK_ID_QUERY_KEY = "taskId";
